/* eslint-disable react/prop-types */
import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { PAGE_ITEMS_COUNT } from "../../constants";
import Spinner from "components/Spinners/Spinner";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import SearchIcon from "@material-ui/icons/Search";
import ArrowLeft from "@material-ui/icons/ArrowLeft";
import ArrowRight from "@material-ui/icons/ArrowRight";
import AddIcon from "@material-ui/icons/Add";
import HomeIcon from "@material-ui/icons/Home";
import Typography from "@material-ui/core/Typography";

import "../../shared/styles/sharedStyles.scss";
import "./ScrollableTable.scss";
import { useSelector } from "react-redux";

const Pagination = ({ data, previousPage, nextPage, numberOfPages, currentPage, indexOfFirstRecord, indexOfLastRecord }) => {
  return <div className="pagination-box">
    <label className="pagination-label">
      {indexOfFirstRecord + 1 +
        "-" +
        indexOfLastRecord +
        " of " +
        data?.length}
    </label>
    <div className="pagination-left">
      <button onClick={() => previousPage()} disabled={currentPage === 1}>
        <ArrowLeft />
      </button>
    </div>
    <div className="pagination-right">
      <button
        onClick={nextPage}
        disabled={currentPage === numberOfPages}
      >
        <ArrowRight />
      </button>
    </div>
  </div>
}

const ScrollableTable = ({
  addItemTitle,
  data,
  header,
  loadData,
  loading,
  minWidth,
  showAddItemDialog,
  title,
  total,
  updateData,
  isUserTable,
  isReferralCodeTable,
  breadCrumbs,
  breadcrumbsIcon,
  searchComponent,
  addItemExtendMenu,
  setReferralSearch,
  additionalFilters,
}) => {
  // eslint-disable-next-line
  const role = useSelector(state => state.auth.role);

  const [localData, setData] = useState([])
  const [search, setSearch] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  // No of Records to be displayed on each page   
  const [recordsPerPage] = useState(PAGE_ITEMS_COUNT);
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;

  const currentRecords = localData.slice(indexOfFirstRecord, indexOfLastRecord);
  const [numberOfPages, setNumberOfPages] = useState(Math.ceil(localData.length / recordsPerPage))

  const myNextPage = () => {
    if (currentPage !== numberOfPages) {
      setCurrentPage(currentPage + 1)
    }
  }

  const myPrevPage = () => {
    if (currentPage !== 1)
      setCurrentPage(currentPage - 1)
  }

  useEffect(() => {
    if (search && data) {
      setData(data.filter(item => isUserTable ? item.columns[0].props.children.toLowerCase().includes(search.toLowerCase()) : isReferralCodeTable ? item.columns[1].toLowerCase().includes(search.toLowerCase()) : item.columns[0].toLowerCase().includes(search.toLowerCase())))
      setCurrentPage(1)
    }
    else if (data) {
      setData(data)
    }
  }, [data, search, isUserTable, isReferralCodeTable])

  useEffect(() => {
    if (localData.length && !loading) {
      setNumberOfPages(Math.ceil(localData.length / recordsPerPage))
    }
    // eslint-disable-next-line
  }, [localData.length, loading]);

  const usePrevious = (value) => {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  };

  useEffect(() => {
    loadData(0, total)
  }, [total, loadData])

  useEffect(() => {
    if (updateData) {
      loadData(0, total);
    }
    // eslint-disable-next-line
  }, [updateData]);

  useEffect(() => {
    if (currentPage > numberOfPages && numberOfPages > 0) {
      setCurrentPage(numberOfPages)
    }
  }, [currentPage, numberOfPages])

  const home = `${process.env.PUBLIC_URL}/admin/curriculum`;
  const prevPage = usePrevious(currentPage - 1);

  return (
    <div className="scrollable-table-container container">
      {role === "ADMIN" &&
        <Breadcrumbs separator="›" className="bread-crumbs" aria-label="breadcrumb">
          <Link to={home}>
            <HomeIcon /> Home
          </Link>
          {breadCrumbs &&
            breadCrumbs.map((item) => {
              return (
                <Link to={item.href} key={item.href}>
                  {item.icon}
                  {item.title}
                </Link>
              );
            })}
          <Typography>
            {breadcrumbsIcon}
            {title}
          </Typography>
        </Breadcrumbs>
      }


      <div className="scrollable-table-controls">
        {searchComponent && (
          <div className="" style={{ display: "flex", gap: "30px" }}>
            <div className="search">
              <SearchIcon />
              <input
                name="name"
                placeholder={isReferralCodeTable ? 'Search by last name' : "Search"}
                type="search"
                onChange={(event) => setSearch(event.target.value)}
              />
            </div>
            {
              isReferralCodeTable &&
              <div className="search">
                <SearchIcon />
                <input
                  name="name"
                  placeholder="Search by referral code"
                  type="search"
                  onChange={(event) => setReferralSearch(event.target.value)}
                />
              </div>}
            {additionalFilters || null}
          </div>
        )}
        {addItemTitle && (
          <div className="create-entity">
            <button onClick={showAddItemDialog}>
              <AddIcon /> {addItemTitle}
            </button>
          </div>
        )}
        {addItemExtendMenu && <div className="create-entity">{addItemExtendMenu}</div>}
      </div>
      <div className="scrollable-table-block">
        <div className="scrollable-table-header" style={{ minWidth: minWidth ? minWidth : "1280px" }}>
          {header.map((item, i) => {
            return (
              <div key={i} className={item.className} style={{ width: item.width }}>
                {item.value}
              </div>
            );
          })}
        </div>
        {!currentRecords.length ? (
          !loading ? (
            <p>Records not found</p>
          ) : (
            ""
          )
        ) : (
          <div>
            <div className="scrollable-table-body" style={{ minWidth: minWidth ? minWidth : "1280px" }}>
              {currentRecords.map((record, rowIndex) => {
                return (
                  <div className="scrollable-table-item" key={rowIndex}>
                    {record.columns.map((item, columnIndex) => {
                      return (
                        <div
                          key={columnIndex}
                          className={header[columnIndex].className}
                          style={{ width: header[columnIndex].width }}
                        >
                          {item}
                        </div>
                      );
                    })}
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
      <div className="scrollable-table-pagination">
        <Pagination
          prevPage={prevPage}
          data={localData}
          previousPage={myPrevPage}
          nextPage={myNextPage}
          currentPage={currentPage}
          numberOfPages={numberOfPages}
          indexOfFirstRecord={indexOfFirstRecord}
          indexOfLastRecord={currentPage === numberOfPages ? localData.length : indexOfLastRecord} />
      </div>

      <Spinner loading={loading} />
    </div>
  );
};

export default ScrollableTable;
